import { render, staticRenderFns } from "./AppPermissions.vue?vue&type=template&id=73d226d5"
import script from "./AppPermissions.vue?vue&type=script&lang=js"
export * from "./AppPermissions.vue?vue&type=script&lang=js"
import style0 from "./AppPermissions.vue?vue&type=style&index=0&id=73d226d5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports